// extracted by mini-css-extract-plugin
export default {"manage-alerts-grid-container":"page_manage-alerts-grid-container__GUSQF","overflow-content":"page_overflow-content__WOIph"};